// extracted by mini-css-extract-plugin
export default {"tabs":"style_tabs__wJWRx"};